<div class="zwi-bottom-app-bar" [class]="{'zwi-bottom-app-bar-ios': isIOS, 'zwi-bottom-app-bar-android': isAndroid}">
  <zwi-nav-tabs [menuItems]="menuItems"></zwi-nav-tabs>
</div>
@if (isIOS) {
  <div class="zwi-bottom-spacer"></div>
}
